// extracted by mini-css-extract-plugin
export var closeButton = "_c8-1";
export var closeX = "_c8-3";
export var container = "_c8-0";
export var image = "_c8-2";